import { render, staticRenderFns } from "./_popin.vue?vue&type=template&id=26b22cc7&scoped=true&"
import script from "./_popin.vue?vue&type=script&lang=js&"
export * from "./_popin.vue?vue&type=script&lang=js&"
import style0 from "./_popin.vue?vue&type=style&index=0&id=26b22cc7&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b22cc7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageTitle: require('/opt/build/repo/components/PageTitle.vue').default,TitleColorDuo: require('/opt/build/repo/components/TitleColorDuo.vue').default,EventCard: require('/opt/build/repo/components/EventCard.vue').default})
